import React from 'react';
import Slider from 'rc-slider';
import {
    FormGroup,
    Input,
    Row,
    Col,
  } from "reactstrap";
import {GeneralSpeedCalculate} from './../../helperFunctions/TrainingSpeeds'
import { useSelector, useDispatch } from 'react-redux'
import {convertMetrics,metricSpeed} from '../../helperFunctions/measurementSystem'
function DayPlanModalCreate (props){
        var user = useSelector(state => state.auth)
        const runType = (percent) =>{
            if (percent>80){
                return "Threshold"
            }
            if (percent>70){
            return "Aerobic 2"
            }
            if (percent>60){
            return "Aerobic 1"
            }
            if (percent>50){
            return "Base/Long Run"
            }
            else{
                return " "
            }
        }
        const colorText = () => {
    
            if (Number(reserve(heartRate(props.hrPerc))) > 90){
              return 'text-danger'
            }
            if (Number(reserve(heartRate(props.hrPerc))) > 80){
              return 'text-warning'
            }
            if (Number(reserve(heartRate(props.hrPerc))) > 70){
              return 'text-success'
            }
            if (Number(reserve(heartRate(props.hrPerc))) > 60){
              return 'text-info'
            }
            
            return 'text-white'
        }        
        const reserve = (heartRate) =>{
            var res = (heartRate - props.user.rest_hr)/(props.user.max_hr-props.user.rest_hr)
            res = parseInt(res*100)
            return res
        }
        const heartRate = (hrDay) =>{
            return parseInt(props.user.max_hr*hrDay/100)
        }
        return(
            <div>
            <Col className="pl-4" md="12">
                
            <h5>{props.day}</h5>
                <Input type="select" value={props.pickerType} onChange={(e)=>props.changeValues(props.day,e.target.value,"PickerType")}style={{backgroundColor:'rgb(40,40,40)',color:'#F0A936'}}>
                    <option value ="Run">Run</option>
                    <option value ="Ride">Ride</option>
                    <option value ="Swim">Swim</option>
                    <option value ="Rest">Rest</option>
                </Input>
                {props.pickerType !== "Rest" ? 
                    <FormGroup>
                        
                        <p style={{color:'rgb(248, 239, 255)'}}>Duration</p>
                        <Input type="number" value={props.duration} onChange={(e)=>props.changeValues(props.day,e.target.value,"Duration")} style={{backgroundColor:'rgb(40,40,40)',color:'#F0A936',marginBottom:'5px'}}></Input>
                        <p style={{color:'rgb(248, 239, 255)'}}>Type</p>
                    </FormGroup>
                    : ""
                }
                
                
                {props.pickerType !== "Rest" ? 
                    <Input type="select" value={props.subType} onChange={(e)=>props.changeValues(props.day,e.target.value,"SubType")} style={{backgroundColor:'rgb(40,40,40)',color:'#F0A936',marginTop:'5px'}}>
                        <option value ="Steady">Steady</option>
                        <option value ="Interval 1-1">Interval 1-1</option>
                        <option value ="Interval 1-2">Interval 1-2</option>
                        <option value ="Interval 1-3">Interval 1-3</option>
                        <option value ="Interval 2-1">Interval 2-1</option>
                        <option value ="Interval 3-1">Interval 3-1</option>
                    </Input>
                : ""}
            </Col>
            {props.pickerType !== "Rest" ? 
            <>
            <Row>
                
                <Col sm={12} >
                    <div class="form-group">
                        <div className="cardDisplay">
                            <div className="menu">
                                <div className="actions">
                                    <div className="follow-info">
                                        <h2><a href="#"><span className={colorText()} style={{fontSize:'20px'}}>{heartRate(props.hrPer)} </span><small style={{fontSize:'20px'}}>Heart Rate Interval</small></a></h2>
                                        <h2><a href="#"><span className='text-info' style={{fontSize:'20px'}}>{props.hrPer}% </span><small style={{fontSize:'20px'}}>Percent of max </small></a></h2>
                                        <h2><a href="#"><span className="text-white" style={{fontSize:'20px'}}>{reserve(heartRate(props.hrPer))}%</span><small style={{fontSize:'20px'}}>Karvonen (reserve)</small></a></h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    
                </Col>
                
            </Row>
            <Row>          
                <Col className="pl-4" md="12">
                    <hr></hr>
                </Col>
            </Row>
            <Row>
                    <div class="form-group">
                        <div className="cardDisplay">
                            <div className="menu">
                                <div className="actions">
                                    <div className="follow-info">
                                        <h2><a href="#"><span className={colorText()} style={{fontSize:'12px'}}>{runType(reserve(heartRate(props.hrPer)))} </span><small style={{fontSize:'15px'}}>Type</small></a></h2>
                                        <h2><a href="#"><span className='text-info' style={{fontSize:'12px'}}>{convertMetrics(GeneralSpeedCalculate(props.duration,props.hrPer,user),user.measurementSystem)}</span><small style={{fontSize:'15px'}}>Estimated Pace  </small></a></h2>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
               
            </Row>
            <Row>          
                <Col className="pl-4" md="12">
                    <hr></hr>
                </Col>
            </Row>
            
            <Row>
                <Slider min={40} max={100} value={props.hrPer} step={1} onChange={(e)=>props.changeValues(props.day,e,"SetHr")}/>
                
            </Row>
            
            {props.subType.includes("Interval") ? 
            <>
            <Row>
                
                <Col sm={12}>
                <div class="form-group">
                    <div className="cardDisplay">
                        <div className="menu">
                            <div className="actions">
                                <div className="follow-info">
                                    <h2><a href="#"><span className={colorText()} style={{fontSize:'20px'}}>{heartRate(props.hrPerLow)} </span><small style={{fontSize:'20px'}}>Heart Rate </small></a></h2>
                                    <h2><a href="#"><span className='text-info' style={{fontSize:'20px'}}>{props.hrPerLow}% </span><small style={{fontSize:'20px'}}>Percent of max </small></a></h2>
                                    <h2><a href="#"><span className="text-white" style={{fontSize:'20px'}}>{reserve(heartRate(props.hrPerLow))}%</span><small style={{fontSize:'20px'}}>Karvonen (reserve)</small></a></h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </Col>
                
                
            </Row>
            
            
            <Row>          
                <Col className="pl-4" md="12">
                    <hr></hr>
                </Col>
            </Row>
                <Row>
                <div class="form-group">
                        <div className="cardDisplay">
                            <div className="menu">
                                <div className="actions">
                                    <div className="follow-info">
                                        <h2><a href="#"><span className={colorText()} style={{fontSize:'12px'}}>{runType(reserve(heartRate(props.hrPerLow)))} </span><small style={{fontSize:'15px'}}>Type</small></a></h2>
                                        <h2><a href="#"><span className='text-info' style={{fontSize:'12px'}}>{convertMetrics(GeneralSpeedCalculate(props.duration,props.hrPerLow,user),user.measurementSystem)}</span><small style={{fontSize:'15px'}}>Estimated Pace  </small></a></h2>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </Row>
            
                <Slider min={40} max={100} value={props.hrPerLow} step={1}  onChange={(e)=>props.changeValues(props.day,e,"SetLowHr")}/>
                    
                
            
            </> : ""}
            
            </>
            : ""}
         </div>
                    
        )
    
}
export default DayPlanModalCreate;



////onChange={sethrSat}


/*
{picker6 !== "Rest" && subType6 !== "Interval" ? 
<Col className="pl-4" md="12">

<Row>
<label style={{color:'rgb(48, 189, 255)'}}>Heart Rate : <span style={{color:'#F0A936'}}> {heartRate(hrSat)} </span></label>
</Row>
<Row>
<label style={{color:'rgb(48, 189, 255)'}}> Percent of max :<span style={{color:'rgb(200,100,100)'}}>   {hrSat}% of max </span></label>
</Row>
<Row>
<label style={{color:'rgb(48, 189, 255)'}}> Karvonen (reserve) : <span style={{color:'#F0A936'}}>   {reserve(heartRate(hrSat))}% of reserve </span></label>
</Row>


<Slider min={40} max={100} value={hrSat} step={1} onChange={sethrSat}/>
<label style={{color:'rgb(48, 189, 255)'}}>{runType(reserve(heartRate(hrSat)))}</label>
<Row>
<label style={{color:'rgb(48, 189, 255)'}}>Estimated Speed : {runType(reserve(heartRate(hrSat)))}</label>
</Row>


</Col>
: ""}
{subType6 === "Interval" ? 
<Col className="pl-4" md="12">
<label style={{color:'rgb(255, 189, 100)'}}>High Intensity</label>   
<Row>
<label style={{color:'rgb(48, 189, 255)'}}>Heart Rate : <span style={{color:'#F0A936'}}> {heartRate(hrSat)} </span></label>
</Row>
<Row>
<label style={{color:'rgb(48, 189, 255)'}}> Percent of max :<span style={{color:'rgb(200,100,100)'}}>   {hrSat}% of max </span></label>
</Row>
<Row>
<label style={{color:'rgb(48, 189, 255)'}}> Karvonen (reserve) : <span style={{color:'#F0A936'}}>   {reserve(heartRate(hrSat))}% of reserve </span></label>
</Row>

<Slider min={40} max={100} value={hrSat} step={1} onChange={sethrSat}/>
<label style={{color:'rgb(48, 189, 255)'}}>{runType(reserve(heartRate(hrSat)))}</label>
<Row>
<label style={{color:'rgb(48, 189, 255)'}}>Estimated Speed : {runType(reserve(heartRate(hrSat)))}</label>
</Row>

<label style={{color:'rgb(255, 189, 100)'}}>Low Intensity</label>
<Row>
<label style={{color:'rgb(48, 189, 255)'}}>Heart Rate : <span style={{color:'#F0A936'}}> {heartRate(hrSatLow)} </span></label>
</Row>
<Row>
<label style={{color:'rgb(48, 189, 255)'}}> Percent of max :<span style={{color:'rgb(200,100,100)'}}>   {hrSatLow}% of max </span></label>
</Row>
<Row>
<label style={{color:'rgb(48, 189, 255)'}}> Karvonen (reserve) : <span style={{color:'#F0A936'}}>   {reserve(heartRate(hrSatLow))}% of reserve </span></label>
</Row>


<Slider min={40} max={100} value={hrSatLow} step={1} onChange={sethrSatLow}/>
<label style={{color:'rgb(48, 189, 255)'}}>{runType(reserve(heartRate(hrSatLow)))}</label>
<Row>
<label style={{color:'rgb(48, 189, 255)'}}>Estimated Speed : {runType(reserve(heartRate(hrSatLow)))}</label>
</Row>

</Col>
: "" }
</div>


*/